import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getPrivacyPolicy } from '../api/policyRepository'

export const usePolicyStore = defineStore('policy', () => {
  const policyHtml = ref<string | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  async function fetchPolicy(forceRefresh = false): Promise<string | null> {
    if (isLoading.value) {
      return policyHtml.value
    }

    if (!forceRefresh && policyHtml.value) {
      return policyHtml.value
    }

    try {
      isLoading.value = true
      error.value = null

      const response = await getPrivacyPolicy()
      policyHtml.value = response.data.policy

      return policyHtml.value
    } catch (err: any) {
      error.value = err instanceof Error ? err.message : 'Не удалось загрузить политику конфиденциальности'
      policyHtml.value = null
      return null
    } finally {
      isLoading.value = false
    }
  }

  function clearPolicy() {
    policyHtml.value = null
    error.value = null
  }

  return {
    policyHtml,
    isLoading,
    error,
    fetchPolicy,
    clearPolicy
  }
})
